import { InAppNotificationDao, UserNotificationDao } from '@rock/db-admin';
import type { UserId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const inAppDao = new InAppNotificationDao();
const busDao = new UserNotificationDao();

/** A user's in-app inbox (the materialized read-model the app renders), newest first. */
export const inAppNotificationsForUserState = atomFamily(
    (userId: UserId | undefined) => inAppDao.notificationsAtom(userId),
    shallowEqual,
);

/**
 * A user's notification bus events with per-channel `{sent}` outcomes — the source of truth for
 * "did the email/push actually go out". Server-only collection; readable because of the admin rule.
 */
export const userNotificationsBusState = atomFamily(
    (userId: UserId | undefined) => busDao.forUserAtom(userId),
    shallowEqual,
);
